import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, merge, mergeMap, of, pipe, switchMap, tap } from "rxjs";
import { translate } from '@jsverse/transloco';
import { AppNotificationService } from "src/app/shared/services/notification.service";
import * as ImportActions from "./import-actions";
import { Router } from "@angular/router";
import { ImportService } from "src/app/history/services/import-service";

@Injectable()
export class ImportEffets {

    //////////////////
    // GET IMPORTS //
    ////////////////

    // Get Imports
    getImports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ImportActions.getImports), 
            mergeMap(() => {
            return this.importService.getImports({pageNumber: 0, pageSize: 25}).pipe(
                map((response) => 
                    ImportActions.getImportsSuccess({ imports: response.data })
                ), 
                catchError((error) =>
                    of(ImportActions.getImportsFailure({ error: error.message }))
                )
            );
        })
        )
    );

    constructor(
        private actions$: Actions, 
        private importService: ImportService,
        private router: Router,
        private appnotificationService: AppNotificationService) {}
}